import { render, staticRenderFns } from "./RequireAdContract.vue?vue&type=template&id=385e0ca3"
import script from "./RequireAdContract.vue?vue&type=script&lang=js"
export * from "./RequireAdContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports